// assets/dh-product-customize.js
(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  // wait for Design Huddle SDK to be available
  function waitForLib(cb, tries = 60) {
    if (window.DSHDLib && typeof DSHDLib.createProject === "function")
      return cb();
    if (tries <= 0) {
      console.error("[Customize] DSHDLib not available");
      return;
    }
    setTimeout(() => waitForLib(cb, tries - 1), 250);
  }

  function getColorFromUrl() {
    return (
      new URLSearchParams(location.search).get("color") || "white"
    ).toLowerCase();
  }

  function templateFromHandle(h) {
    h = String(h || "").toLowerCase();
    return h;
  }

  // Hash reading lives in dh-common.js as DH.readHash(key).

  function onClick(e) {
    // Works with either a data attribute or the specific id
    const a = e.target.closest("[data-dh-customize], #dh-customize");
    if (!a) return;

    // Let modified clicks (new tab, etc.) behave normally
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1)
      return;

    // Intercept default navigation
    e.preventDefault();

    // Get handle from data attribute OR parse it from the href (?product=...)
    const href = new URL(a.getAttribute("href"), location.href);
    const handle = (
      a.dataset.productHandle ||
      href.searchParams.get("product") ||
      ""
    ).toLowerCase();
    const color = getColorFromUrl();
    const template_code = templateFromHandle(handle || "sticker");

    a.classList.add("is-loading-2");
    a.setAttribute("aria-busy", "true");

    waitForLib(() => {
      // Switch the SDK into guest context for the editor handoff.
      DH.configure("guest");

      const guestHash   = DH.readHash("dh_tco_hash_guest");
      const visitorHash = DH.readHash("dh_tco_hash_visitor");

      // 1. If we already have a guest hash, use it directly (fast path)
      if (guestHash) {
        createProjectAndNavigate(a, template_code, handle, color, guestHash);
        return;
      }

      // 2. If we have a visitor hash, migrate it to guest context
      if (visitorHash) {
        const logoUrl = localStorage.getItem("dh_logo_url");

        if (logoUrl) {
          // Re-create the TCO in guest context
          const tco = {
            object: {
              classes: {
                logo: { url: logoUrl }
              }
            }
          };

          DSHDLib.storeTemplateCustomizationObject(tco, (err, data) => {
            if (err || !data?.object_hash) {
              console.error(
                "[Customize] Failed to migrate TCO to guest context:",
                err
              );
              createProjectAndNavigate(a, template_code, handle, color, null);
              return;
            }

            // Store the new guest-context hash
            localStorage.setItem("dh_tco_hash_guest", data.object_hash);

            createProjectAndNavigate(
              a,
              template_code,
              handle,
              color,
              data.object_hash
            );
          });
        } else {
          // No logo URL, proceed without hash
          createProjectAndNavigate(a, template_code, handle, color, null);
        }
        return;
      }

      // 3. No hash at all, just create project
      createProjectAndNavigate(a, template_code, handle, color, null);
    });

    function createProjectAndNavigate(
      a,
      template_code,
      handle,
      color,
      tcoHash
    ) {
      const createOpts = { template_code };
      if (tcoHash) createOpts.customizations_hash = tcoHash;

      DSHDLib.createProject(createOpts, (err, res) => {
        a.classList.remove("is-loading-2");
        a.removeAttribute("aria-busy");

        if (err || !res?.project_id) {
          console.error("[Customize] createProject failed:", err || res);
          alert("Could not start your design. Please try again.");
          return;
        }

        const url = new URL("/pages/editor", location.origin);
        url.searchParams.set("project_id", res.project_id);
        url.searchParams.set("product", handle);
        url.searchParams.set("color", color);

        location.href = url.toString();
      });
    }
  }

  ready(() => {
    // Use capture so we beat the browser's default link navigation
    document.addEventListener("click", onClick, true);
  });
})();